<template>

  <!-- HEADER LOGO -->
  <!-- <div class="column is-half is-offset-one-quarter">
    <div class="navbar-center has-text-centered"> <img src="./../assets/logodark.png" width="100%"/></div>
  </div> -->
  <div>

    <!-- LOGIN BOX -->
    <div class="needs-padding is-border-green has-background-white center-screen" v-if="!logged">
      <div class="container">
        <div class="container">
          <article class="message is-danger" v-if="logerror">
            <div class="message-header">
              <p>Authentication Error</p>
              <button class="delete" aria-label="error" @click="closeLogErrorMsg"></button>
            </div>
            <div class="message-body">
              It looks that something is wrong. Please check the code and try again later.
            </div>
          </article>
            <div class="field mt-6 m-t-25">
              <div class="control">
                <input class="input font-size-400 " type="text" v-model="accescode" placeholder="Access code"/>
              </div>
            </div>
            <br>
            <br>
            <button class="button has-text-white-ter stblue-background is-rounded calibri is-medium mt-6 calibri font-size-400" @click="login"> Sign in </button>
        </div>
        </div>
    </div>
    <div class="modal is-active" v-if="showpinerror"> 
      <div class="modal-background"></div>
      <div class="modal-card ">
        <header class="modal-card-head has-bg-danger">
          <p class="modal-card-title is-danger text-color-white prevent-select">Authentication Error</p>
          <button class="delete prevent-select" aria-label="close" @click="closePinErrorMsg"></button>
        </header>
        <section class="modal-card-body has-bg-danger-light no-border">
          <div class="content">
            <!-- <h4> The pin code for {{selectegate}} is: </h4> -->
            <h1 class="text-color-red prevent-select"> Incorrect PIN. Try again.</h1> 
          </div>
        </section>
      </div>
    </div>
    <div class="modal is-active" v-if="showpin">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title prevent-select">Code validation</p>
          <button class="delete prevent-select" aria-label="close" @click="closePinMsg"></button>
        </header>
        <section class="modal-card-body">
          <div class="content">
            <!-- <h4> The pin code for {{selectegate}} is: </h4> -->
            <h1 class="text-color-violet prevent-select"> Please proceed to gate</h1> 
          </div>
        </section>
      </div>
      <!-- <button class="modal-close is-large" aria-label="close"></button> -->
    </div>
    <div class="needs-padding  is-border-green has-background-white has-text-centered mt-3 center-screen" v-if="logged">
      <div class="column  has-text-centered">
        <div class="container">
          <div class="box calibri is-medium mt-3 calibri font-size-400">
            <p class="prevent-select">{{code}}</p>
          </div>
        </div>
      </div>
      <div class="mt-6">
      <ul class="flex-container wrap has-text-centered" >
        <li class="box flex-item mx-5 prevent-select" @click="addcode('7')">7</li>
        <li class="box flex-item mx-5 prevent-select" @click="addcode('8')">8</li>
        <li class="box flex-item mx-5 prevent-select" @click="addcode('9')">9</li>
      </ul>
      <ul class="flex-container wrap has-text-centered" >
        <li class="box flex-item mx-5 prevent-select" @click="addcode('4')">4</li>
        <li class="box flex-item mx-5 prevent-select" @click="addcode('5')">5</li>
        <li class="box flex-item mx-5 prevent-select" @click="addcode('6')">6</li>
      </ul>
      <ul class="flex-container wrap has-text-centered" >
        <li class="box flex-item mx-5 prevent-select" @click="addcode('1')">1</li>
        <li class="box flex-item mx-5 prevent-select" @click="addcode('2')">2</li>
        <li class="box flex-item mx-5 prevent-select" @click="addcode('3')">3</li>
      </ul>
      <ul class="flex-container wrap has-text-centered" >
        <li class="box flex-item mx-5 redbox widetile prevent-select" @click="removelast()"><font-awesome-icon icon="backspace"/>
        <li class="box flex-item mx-5 prevent-select" @click="addcode('0')">0</li>
        <li class="box flex-item greenbox widetile mx-5 prevent-select" @click="submitcode()" >OK</li>
      </ul>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  components: {
    // Datepicker
  },
  data(){
    return{
      token: '',
      year: '',
      pin: '',
      logged: false,
      code: 'Enter Code',
      accescode: '',
      logerror: false,
      showpinerror: false,
      showpin: false,
      errormessage: '',
      accesstoken: '',
      access: 0,
    };
  },
  beforeCreate(){
    if(!(typeof localStorage.halotabletaccescode === typeof undefined)){
      if(localStorage.halotabletaccescode !== null && localStorage.halotabletaccescode !== ""){
        const auth = {
          headers: {token:'345jd6454wgergwyg!09i843t'} 
        }
        axios.get("https://mfapi.smarttile.co.uk/api/accesspod/getaccesstoken?code=" + localStorage.halotabletaccescode, auth)
        .then((res)=> {
          if(res.status === 200){
            if(res.data === null){
              this.logerror = true;
              this.logged = false;
            }
            else{
              this.accesstoken = res.data.accesstoken;
              this.access = res.data.access;
              this.logged = true;
              // localStorage.accescode = this.accescode;
              // var list = [889, 890, 891, 892, 893, 894, 897, 898, 899, 900, 901];
              // //check if res.data.access in list
              // if(list.includes(res.data.access)){
              //   //add meta to head to reload every 30 seconds
              //   var meta = document.createElement('meta');
              //   meta.httpEquiv = "refresh";
              //   meta.content = "30";
              //   document.getElementsByTagName('head')[0].appendChild(meta);
              // }
            }
          }
          else{
            this.logerror = true;
            this.logged = false;            
          }
        }).catch((error)=>{
          console.log(error);
          this.logerror = true;
          this.logged = false;
        })
      }
    }
  },
  created(){

    let dt = new Date();
    var date = dt.getFullYear()+'-'+(dt.getMonth()+1)+'-'+dt.getDate();
    this.initdate = date;
    this.enddate = date;
    this.year = dt.getFullYear();

      
  },
  methods:{
    closeLogErrorMsg(){
      this.logerror = false;
    },
    closePinErrorMsg(){
      this.showpinerror = false;
      this.code = 'Enter Code';
    },
    closePinMsg(){
      this.showpin = false;
    },
    addcode(number){
      if(this.code==='Enter Code'){
        this.code = number;
      }
      else{
        let c = this.code + number;
        this.code = c;
      }
    },
    removelast(){
      if(this.code === 'Enter Code'){
        return;
      }
      if(this.code.length === 1){
        this.code = 'Enter Code'
      }
      else{
        let str = this.code.substring(0, this.code.length - 1);
        this.code = str;
      }
    },
    login(){
      const auth = {
        headers: {token:'345jd6454wgergwyg!09i843t'} 
      }
      axios.get("https://mfapi.smarttile.co.uk/api/accesspod/getaccesstoken?code=" + this.accescode, auth)
      .then((res)=> {
        if(res.status === 200){
          if(res.data === null){
            this.logerror = true;
            this.logged = false;
          }
          else{
            this.accesstoken = res.data.accesstoken;
            this.access = res.data.access;
            this.logged = true;
            localStorage.halotabletaccescode = this.accescode;
            var list = [889, 890, 893];
            console.log(list);
            console.log(res.data.access);
            //check if res.data.access in list
            if(list.includes(res.data.access)){
              //add meta to head to reload every 30 seconds
              console.log('reloading');
              var meta = document.createElement('meta');
              meta.httpEquiv = "refresh";
              meta.content = "30";
              document.getElementsByTagName('head')[0].appendChild(meta);
            }
          }
        }
        else{
          this.logerror = true;
          this.logged = false;            
        }
      }).catch((error)=>{
        console.log(error);
        this.logerror = true;
        this.logged = false;
      })
    },
    submitcode(){
      const auth = {
        headers: {token:'345jd6454wgergwyg!09i843t'} 
      }
      if(this.code == "7777"){
        window.location.reload();
        return;
      }
      axios.get("https://mfapi.smarttile.co.uk/api/accesspod/getaccessforpin?session=" + this.accesstoken + "&access=" + this.access + "&pin=" + this.code, auth)
      .then((res)=> {
        if(res.status === 200){
            if(res.data === null){
              this.showpinerror = true;
              let self = this;
              setTimeout(function () {
                if(self.showpinerror){
                  self.closePinErrorMsg();
                }
              }, 2000);
            }
            else{
              if(res.data == 1){
                this.showpinerror = false;
                this.showpin = true;
                this.code = 'Enter Code';
                let self = this;
                setTimeout(function () {
                  self.showpin = false;
                }, 2000);
              }
              else{
                this.showpinerror = true;
                let self = this;
                setTimeout(function () {
                  if(self.showpinerror){
                    self.closePinErrorMsg();
                  }
                }, 2000);
              }
            }
          }
          else{
            this.showpinerror = true;
            let self = this;
            setTimeout(function () {
              if(self.showpinerror){
                self.closePinErrorMsg();
              }
            }, 2000);           
          }
      }).catch((error)=>{
        console.log(error);
        this.showpinerror = true;
        let self = this;
        setTimeout(function () {
          if(self.showpinerror){
            self.closePinErrorMsg();
          }
        }, 5000);
      })
    },
    logOut(){
      window.location.reload();
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.center-screen {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
}
body{
    touch-action: manipulation !important;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
  touch-action: none !important;
}
a {
  background-color: #232323;
  color: white;
}
a:hover{
  background-color: white;
  color: #232323;
  border-color: #232323;
}
.prevent-select {
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
}
.greenbox{
  background-color: green !important;
  /* color: black; */
}
.has-bg-danger{
  background-color: #cc0f35;
}
.has-bg-danger-light{
  background-color: #ffd2db;
}
.text-color-white{
  color: white !important;
}
.text-color-red{
  color: #cc0f35 !important;
}
.no-border{
  border-width: 0 !important;
}
/* .greenbox:hover{
  background-color: white !important;
  color: green !important;
} */
.redbox{
  background-color: red !important;
  /* color: black; */
}
/* .redbox:hover{
  background-color: white !important;
  color: red !important;
} */
.widetile{
  width: 4rem;
}
/* .box:hover{
  border-color: #603 !important;
} */
font-awesome-icon{
  color: #232323;
}
.flex-container {
  padding: 0;
  margin: 0;
  list-style: none;
  -ms-box-orient: horizontal;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -moz-flex;
  display: -webkit-flex;
  display: flex;
  justify-content: center;
}

.nowrap  { 
  -webkit-flex-wrap: nowrap;
  flex-wrap: nowrap;
}

.wrap    { 
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
}  
.wrap li {
  background: #232323;
}

.wrap-reverse         { 
  -webkit-flex-wrap: wrap-reverse;
  flex-wrap: wrap-reverse;
}  
.wrap-reverse li {
  background: #232323;
}

.flex-item {
  background: #232323;
  padding: 5px;
  width: 7rem;
  height: 7rem;
  margin: 10px;
  line-height: 7rem;
  color: white;
  font-weight: bold;
  font-size: 6em;
  text-align: center;
  font-size: 36px;
}
/* .flex-item:hover{
  background: gold;
  color: #603;
} */
.stblue-background {
  background-color: #232323;
}
.stblue-foreground{
  color: #232323;
}
.white-background{
  background-color: #fff; 
}
.calibri {
  font-family: Calibri, 'Gill Sans', 'Gill Sans MT', 'Trebuchet MS', sans-serif;
  font-weight: normal;
}
.font-size-400{
  font-size: 400% !important;
}
.font-size-200{
  font-size: 200%;
}
.font-size-150{
  font-size: 150%;
}
.calibri-bold{
  font-weight: bold;
}
.m-t-25{
  margin: 25px;
}
.m-t-12{
  margin: 12px;
}
.table {
      margin-left: auto;
      margin-right: auto;
    }
    .table__wrapper {
  overflow-x: auto;
}
.vt-sort:before{
    font-family: FontAwesome;
    padding-right: 0.5em;
    width: 1.28571429em;
    display: inline-block;
    text-align: center;
}
</style>
